<script>
    export default {
        methods: {
            isSelected(value, columns) {
                return columns.includes(value);
            },
            addComma(value) {
                if (value === undefined || value === null) {
                    return '';
                }
                return Number(value).toLocaleString();
            }
        }
    }
</script>